import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { ThemeToggle } from './ThemeToggle';
import { UserMenu } from './UserMenu';

export function PrimaryHeader() {
  return (
    <header className="sticky top-0 z-50 w-full bg-background border-b">
      {/* Content Wrapper */}
      <div className="w-full flex items-center justify-between">
        {/* Logo and Branding */}
        <Link to="/" className="flex items-center gap-2">
          <img
            src="/assets/images/Gather_Icon.svg"
            alt="Gather Icon"
            className="h-6 w-6"
          />
          <span className="font-bold hidden sm:inline-block">QS Tools</span>
        </Link>

        {/* Action Buttons */}
        <div className="flex items-center gap-2">
          <ThemeToggle />
          <UserMenu />
        </div>
      </div>
    </header>
  );
}
